import React from 'react';
import EphotobookShareModal from './EphotobookShareModal';
import config from '../../../config';
import { HTMLTrans } from '../../Common/Translations';
import { OWNER } from './Constants';

export const EPhotobookLineItem = ({ item, index, currentPage, currentSelectedType = OWNER}) => (
    <div className='ephotobook-card'>
        <div className='row col justify-content-center justify-content-lg-between'>
            <div className='d-flex justify-content-center viewcomp-generating-preview'>
                {
                    item.preview_img === null ?
                        (
                            <div className='d-flex flex-column align-items-center justify-content-center viewcomp-generating-preview border border-1 rounded'>
                                <img className='img-fluid mb-3' src={`${config.s3BucketUrl}/assets/general/printer-icon.png`} width='48'/>
                                <p className='my-0 text-blue'>
                                    <HTMLTrans id='account.ephotobook_printing'>
                                        “Printing” ePhotobook...
                                    </HTMLTrans>
                                </p>
                            </div>
                        )
                    :
                    <img src={`${item.preview_img}`} className='viewcomp-generating-preview'/>
                }
            </div>
            <div className='col d-flex flex-column justify-content-center'>
                {currentSelectedType !== OWNER && item.owner && <p className='mt-2 mb-1 shared-by-text'><HTMLTrans id='account.ephotobook_shared_by_owner_name'>Shared by</HTMLTrans> {item.owner.name}</p>}
                <h5 className='ProximaNova-Bold mb-1'><HTMLTrans id={`account.ephotobook_title_${item.title}`}>{`${item.title}`}</HTMLTrans></h5>
                <p className='mb-1'><HTMLTrans id={`account.ephotobook_product_name_${item.product_name}`}>{`${item.product_name}`}</HTMLTrans></p>
                <p className='mb-3'>{`${item.total_page}`} <HTMLTrans id='account.ephotobook_pages'> Pages</HTMLTrans></p>
                { 
                    item.preview_img === null && item.purchasable === false ?
                        (
                            <div className='d-inline rounded p-2 bg-primary-lighten-2'>
                                <img className='d-inline img-fluid mr-2' src={`${config.s3BucketUrl}/assets/general/info-icon.png`} width='16'/>
                                <p className='d-inline my-0 bulk-order-banner__description text-blue'>
                                    <HTMLTrans id='account.ephotobook_processed_msg'>
                                        Your ePhotobook is currently being processed, you will be able to preview it shortly.
                                    </HTMLTrans>
                                </p>
                            </div>
                        )
                    :
                        <EphotobookShareModal
                            currentPage={currentPage}
                            item={item}
                            index={index}
                            currentSelectedType={currentSelectedType}
                        />
                }
            </div>
        </div>
        <hr className='bg-gray-lighten-1 my-3'/>
    </div>
);

export const EmptyEPhotobookContent = () => (
    <div className='container my-5'>
        <div className="row col justify-content-center justify-content-lg-between">
            <div className="row col justify-content-center">
            <p><HTMLTrans id="account.ephotobook_empty_list">You do not have any projects to share yet.</HTMLTrans></p>
            </div>
        </div>
        <hr className='bg-gray-lighten-1 my-5'/>
    </div>
);



// WEBPACK FOOTER //
// ./src/Account/EPhotobook/ViewComp.js